module.exports = __webpack_public_path__ + "static/media/icon_102.70806192.svg";